module.exports = __webpack_public_path__ + "img/4.fc5b254c.png";